// extracted by mini-css-extract-plugin
export default {"product-type-container":"product-type-container"};